var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { ODWebUtils } from '../../utils';
var Line = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n"])), function (p) { return ODWebUtils.addPostfixIfNumber(p.width || 1, 'px'); }, function (p) { return ODWebUtils.addPostfixIfNumber(p.height, 'px'); }, function (p) { return p.color; });
export var ODVLine = function (props) {
    return React.createElement(Line, __assign({}, props), props.children);
};
var templateObject_1;
//# sourceMappingURL=ODVLine.js.map